<template>
    <SmartLinkItemComponent v-if="model" :id="model?.system?.id" :component="!model.system.workflow">
        <div class="banner" :class="backgroundColor">
            <div class="container" :class="{'pt-0': paddingModifications['pt-0'], 'pb-0': paddingModifications['pb-0'], 'placement-left': imagePlacement == 'left'}" :style="backgroundImage">

                <template v-if="layout == 'split'">
                    <div class="row">
                        <div class="col-lg-6" data-aos="fade-in">
                            <div class="title" v-if="model?.elements?.title?.value">
                                <SmartLinkStandaloneElement :codename="type.elements.title.codename">
                                    <h2>{{ model?.elements?.title?.value }}</h2>
                                </SmartLinkStandaloneElement>
                            </div>
                            <div class="primary-content" v-if="!isEmpty(model?.elements?.primary_content?.value)">
                                <SmartLinkStandaloneElement :codename="type.elements.primary_content.codename">
                                    <RichText :value="model.elements.primary_content.value" />
                                </SmartLinkStandaloneElement>
                            </div>
                            <div class="cta" v-if="model?.elements?.call_to_action?.value?.length > 0 && !isMobile">
                                <CallToAction v-for="cta in pageStore.getListAs<CallToActionModel>(model?.elements?.call_to_action?.value)" :model="cta"/>
                            </div>
                        </div>
                        <div class="col-lg-6" v-if="!isEmpty(model?.elements?.secondary_content?.value)" data-aos="fade-in">
                            <div class="secondary-content">
                                <SmartLinkStandaloneElement :codename="type.elements.secondary_content.codename">
                                    <RichText :value="model.elements.secondary_content.value" />
                                </SmartLinkStandaloneElement>                        
                            </div>
                            <div class="cta" v-if="model?.elements?.call_to_action?.value?.length > 0 && isMobile">
                                <CallToAction v-for="cta in pageStore.getListAs<CallToActionModel>(model?.elements?.call_to_action?.value)" :model="cta"/>
                            </div>
                        </div>
                    </div>                    
                </template>

                <template v-else>
                    <div class="row">
                        <div class="col-lg" data-aos="fade-in">
                            <div class="title" v-if="model?.elements?.title?.value">
                                <SmartLinkStandaloneElement :codename="type.elements.title.codename">
                                    <h2>{{ model?.elements?.title?.value }}</h2>
                                </SmartLinkStandaloneElement>
                            </div>
                            <div class="primary-content" v-if="!isEmpty(model?.elements?.primary_content?.value)">
                                <SmartLinkStandaloneElement :codename="type.elements.primary_content.codename">
                                    <RichText :value="model.elements.primary_content.value" />
                                </SmartLinkStandaloneElement>
                            </div>
                            <div class="secondary-content" v-if="!isEmpty(model?.elements?.secondary_content?.value)">
                                <SmartLinkStandaloneElement :codename="type.elements.secondary_content.codename">
                                    <RichText :value="model.elements.secondary_content.value" />
                                </SmartLinkStandaloneElement>                        
                            </div>
                            <div class="cta" v-if="model?.elements?.call_to_action?.value?.length > 0">
                                <CallToAction v-for="cta in pageStore.getListAs<CallToActionModel>(model?.elements?.call_to_action?.value)" :model="cta"/>
                            </div>
                        </div>
                    </div>
                </template>

            </div>
        </div>
    </SmartLinkItemComponent>
</template>

<script lang="ts" setup>
import type { BannerModel, CallToActionModel } from '~~/app/models';
import { contentTypes } from '~~/app/models'
import getPaddingModifications from '~~/app/utils/get-padding-modifications';
const pageStore = usePageStore();
const type = contentTypes.banner;
const props = defineProps<{ model: BannerModel }>();

const {deviceIsMobile} = useScreenHelper();
const isMobile = ref(false);

const paddingModifications = computed(() => getPaddingModifications(props?.model?.elements?.padding_modifications__padding_modifications))

// left or right - right as default
const imagePlacement = computed(() => firstOrDefault(props?.model?.elements?.image_placement?.value)?.codename ?? 'right');

// split, container, full-width - split as default
const layout = computed(() => firstOrDefault(props?.model?.elements?.layout?.value)?.codename ?? 'split');

// background image
const backgroundImage = computed(() => {
    return props.model?.elements?.image?.value?.[0]?.url ? { 'background-image': `url(${props.model?.elements?.image?.value?.[0]?.url})` } : {};
});

// background color
const backgroundColor = computed(() => {
    switch (firstOrDefault(props?.model?.elements?.design?.value)?.codename) {
        case 'light':
            return 'bg-white';
        case 'dark':
            return 'bg-navy';
        default:
            return '';
    }
});

onMounted(() => {
    isMobile.value = deviceIsMobile();
    addEventListener("resize", (event) => {
        isMobile.value = deviceIsMobile();
    });
})
</script>